import { SelectItemModel } from '@app/src/common/Select/SelectModel';
import { TypePropertyModel } from '@app/src/views/StepOne/form';

export const hydrateData = (data: TypePropertyModel[]) =>
  data.map((item) => ({
      value: String(item.id),
      text: item.name,
      data: {...item}
  })) as SelectItemModel[]
